module.exports = __webpack_public_path__ + "static/media/frc-easter-image-3.ee0eb3fa.jpg";